var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-avatar',{attrs:{"src":_vm.src,"variant":"light"}},[(!_vm.src)?_c('span',{staticClass:"initial"},[_vm._v(_vm._s(_vm.userInitial))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }